export const IMAGE_GEN_AVAILABLE_STYLE = {
  digital_style: {
    id: 'digital-style',
    text: 'Digital',
    subStyles: [
      {
        id: 'none',
        text: 'None',
        imagePath: '/none.png',
      },
      {
        id: 'abstract_collage',
        text: 'Abstract Collage',
        imagePath: '/abstract-collage.png',
      },
      {
        id: 'landscape_photorealism',
        text: 'Landscape Photorealism',
        imagePath: '/landscape-photorealistic.png',
      },
      {
        id: 'neon_glow_cyberpunk',
        text: 'Neon Glow Cyberpunk',
        imagePath: '/neonglow-cyberpunk.png',
      },
      {
        id: 'photorealistic_profile',
        text: 'Photorealistic Profile',
        imagePath: '/photorealistic-profile.png',
      },
      {
        id: 'realistic_3d_object',
        text: 'Realistic 3D',
        imagePath: '/realistic-3d.png',
      },
    ],
  },
  traditional_style: {
    id: 'traditional-style',
    text: 'Traditional',
    subStyles: [
      {
        id: 'none',
        text: 'None',
        imagePath: '/none.png',
      },
      {
        id: 'watercolor_painting',
        text: 'Watercolour',
        imagePath: '/watercolor.png',
      },
      {
        id: 'oil_painting',
        text: 'Oil',
        imagePath: '/oil.png',
      },
      {
        id: 'crayon_art',
        text: 'Crayon',
        imagePath: '/crayon.png',
      },
      {
        id: 'pastel_palette',
        text: 'Digital Palette',
        imagePath: '/pastel-palette.png',
      },
      {
        id: 'grayscale_sketch',
        text: 'Grayscale Sketch',
        imagePath: '/grayscale-sketch.png',
      },
    ],
  }
};

export const EXTERNAL_IMAGE_TOOLS = [
  {
    id: 'image-upscale',
    text: 'Upscale Image',
    imagePath: '/test.png',
    link: '/upscale-image/get-started'
  },
  {
    id: 'object-remover',
    text: 'Remove Objects',
    imagePath: '/test.png',
    link: '/object-remover/get-started'
  },
  {
    id: 'object-replacer',
    text: 'Replace Objects',
    imagePath: '/test.png',
    link: '/object-replacer/get-started'
  },
];
